export const setPayoutsPagination = {
  SET_PAYOUTS_PAGINATION(state, payload) {
    state.payoutsPagination = payload;
  }
};
